// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-HezXU";
var _3 = "header-2PGR3";
var _4 = "selected-3KPpZ";
var _5 = "title-2Qk0U";
var _6 = "icon-27HFb";
var _7 = "info-PjlC6";
var _8 = "description-3ReJO";
var _9 = "footer-oj0Sp";
var _a = "price-1efn3";
var _b = "button-2PGA_";
var _c = "button_edit-aR-AO";
export { _1 as "__esModule", _2 as "wrapper", _3 as "header", _4 as "selected", _5 as "title", _6 as "icon", _7 as "info", _8 as "description", _9 as "footer", _a as "price", _b as "button", _c as "button_edit" }
export default { "__esModule": _1, "wrapper": _2, "header": _3, "selected": _4, "title": _5, "icon": _6, "info": _7, "description": _8, "footer": _9, "price": _a, "button": _b, "button_edit": _c }
